// extracted by mini-css-extract-plugin
export default {"day-progress-bar__label":"styles_day-progress-bar__label__G-LOB","day-progress-bar__bar":"styles_day-progress-bar__bar__dgt8J"};